import { Component } from "@kluntje/core";
import { findAll, find } from "@kluntje/js-utils/lib/dom-helpers";

class FRASwapInputs extends Component {
  constructor() {
    super({
      ui: {
        swapButton: ".fra-js-swap-inputs__button :-one",
        inputs: ".fra-js-swap-inputs__input",
        autocomplete: ".fra-js-autocomplete",
      },
      events: [
        {
          event: "click",
          target: "swapButton",
          handler: "handleClick",
        },
        {
          event: "fra-autocomplete-input-value",
          target: "autocomplete",
          handler: "clearInputHidden",
        },
        {
          event: "input",
          target: "inputs",
          handler: "clearInputHidden",
        },
      ],
    });
  }

  /**
   * Swap the inputs value and the hidden inputs value
   */
  handleClick(): void {
    const { inputs } = this.ui;
    const inputsHidden = findAll(this, "input[type=hidden]");
    const inputValues: any[] = [];
    const inputIds: any[] = [];

    inputs.forEach((inputElement: HTMLInputElement) => {
      const input = inputElement;
      const dataId = input.getAttribute("data-id");
      inputValues.push(input.value);
      inputIds.push(dataId === null ? "" : dataId);
    });

    const swappedValues: any[] = inputValues.reverse();
    const swappedIds: any[] = inputIds.reverse();

    if (inputs[0] as HTMLInputElement) (inputs[0] as HTMLInputElement).value = swappedValues[0];
    if (inputs[1] as HTMLInputElement) (inputs[1] as HTMLInputElement).value = swappedValues[1];

    if (inputs[0] as HTMLInputElement) (inputs[0] as HTMLInputElement).setAttribute("data-id", swappedIds[0]);
    if (inputs[0] as HTMLInputElement) (inputs[1] as HTMLInputElement).setAttribute("data-id", swappedIds[1]);

    if (inputsHidden[0] as HTMLInputElement) (inputsHidden[0] as HTMLInputElement).value = swappedIds[0];
    if (inputsHidden[1] as HTMLInputElement) (inputsHidden[1] as HTMLInputElement).value = swappedIds[1];
  }

  /**
   * clear the input hidden value
   * @param {event} event - custom event dispatched from  FRAAirportsInput component
   */
  clearInputHidden(event: CustomEvent): void {
    const autosuggestInput = find(event.target as HTMLElement, ".fra-js-autocomplete__input") as HTMLInputElement;
    const hiddenInput = find(event.target as HTMLElement, "input[type=hidden]") as HTMLInputElement;

    if (autosuggestInput !== null && !autosuggestInput.value) {
      hiddenInput.value = "";
    }
  }
}

customElements.define("fra-e-swap-inputs", FRASwapInputs);

export default FRASwapInputs;
